import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { global } from '@shared/services/global';
import { ApiResponse } from '@shared/models/api-response';

import { ApiTranslatorService } from '@shared/services/api-translator.service';
import { map } from 'rxjs/operators';
import { Client } from '@shared/models/client';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private _url: string;

  constructor(private _http: HttpClient, private _apiTranslatorService: ApiTranslatorService) {
    this._url = global.url;
  }

  getDebtorUsers(): Observable<Client[]> {
    return this._http
      .get<ApiResponse>(`${this._url}user/recibo-cliente`)
      .pipe(map(res => res.data.map((data: any) => this._apiTranslatorService.modelToCamelCase(Client, data))));
  }

  checkToken(token: string | null): Observable<ApiResponse> {
    const obj = { token: token };
    const json = JSON.stringify(obj);
    const params = 'json=' + json;

    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    return this._http.post<ApiResponse>(this._url + 'user/check-token', params, {
      headers: headers,
    });
  }

  changePassword(body: any): Observable<ApiResponse> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this._http.put<ApiResponse>(`${this._url}v1/admin-services/users/change-password`, body, {
      headers: headers,
    });
  }
}
